var _g, _rect, _rect2, _rect3, _g2, _g3, _path, _circle, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestStrat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_19368_25492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 36,
    height: 36,
    rx: 8,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 36,
    width: 20,
    height: 10,
    rx: 2,
    transform: "rotate(-90 4 36)",
    fill: "#FFA300"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 25,
    height: 10,
    rx: 2,
    transform: "rotate(-90 16 36)",
    fill: "#FF6300"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 36,
    width: 31,
    height: 10,
    rx: 2,
    transform: "rotate(-90 28 36)",
    fill: "#FF0400"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_19368_25492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_linear_19368_25492)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint1_radial_19368_25492)",
    fillOpacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_19368_25492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 19.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "url(#paint2_radial_19368_25492)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 19.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "url(#paint3_radial_19368_25492)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 19.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "url(#paint4_radial_19368_25492)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 41L31 46M34 36C34 39.866 37.134 43 41 43C44.866 43 48 39.866 48 36C48 32.134 44.866 29 41 29C37.134 29 34 32.134 34 36Z",
    stroke: "#88A2B1",
    strokeOpacity: 0.2,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "matrix(-1 0 0 1 47 28)",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 40L30 45",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_19368_25492",
    x: 16,
    y: 15,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_19368_25492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_19368_25492",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_19368_25492",
    x: 12,
    y: 11,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_19368_25492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_19368_25492",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_19368_25492",
    x: 16,
    y: 15,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_19368_25492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_19368_25492",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19368_25492",
    x1: 20,
    y1: 19,
    x2: 38,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_19368_25492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 19) scale(36)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_19368_25492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 42.5) rotate(6.1155) scale(14.0801)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_19368_25492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5 25.5) rotate(135) scale(6.36396 28.1317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_19368_25492",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5 26) rotate(116.565) scale(16.7705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestStrat);
export default __webpack_public_path__ + "static/media/TestStrat.6c56c61b128669737e8a6b2e943273bd.svg";
export { ForwardRef as ReactComponent };